const logoPaginaDofollow = 'Logo en la página del programa en TNO Network (sección Anunciantes) con enlace dofollow.';

const optionsData = [
  {
    title: 'Sponsorship 3 de Copas',
    annualPrice: 'Trimestral: 360',
    monthlyPrice: 120,
    features: [
      'Tres menciones en vivo: al entrar, en el desarrollo (aquí se explica tu marca) y salida',
      'Video comercial de 20 segundos durante el programa',
      'Transmisión en vivo en TNO Network (promo redes: jueves 3:00 PM; confirma grilla)',
      'Presencia en Web, App y Redes Sociales del ecosistema',
      'Asociación con lifestyle, transformación personal y conversación de calidad',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas de bienestar, moda, belleza, servicios personales y lifestyle que buscan cercanía y storytelling.',
    duration: 'Mensual',
    buttonText: 'Patrocinar 3 de Copas',
    highlightedTitle: 'Presencia que se siente en vivo',
    highlightedContent: [
      'Tu marca acompaña el ritual semanal de 3 de Copas con Zidney.',
      'Tres menciones + comercial de 20 segundos dentro del programa.',
      'Temas de transformación, estilo y cultura en un solo espacio.',
    ],
    highlightedButtonText: 'Ver el programa en TNO',
  },
  {
    title: 'Segmento exclusivo por tema',
    annualPrice: 'Trimestral: 180',
    monthlyPrice: 60,
    features: [
      'Mención exclusiva: "Este segmento presentado por..."',
      'Vinculación con una temática: Autoconocimiento, Moda, Bienestar emocional o Relaciones',
      'Contenido alineado con el ADN de tu marca',
      'Presencia en el bloque correspondiente del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que quieren autoridad en un nicho sin patrocinar el programa completo.',
    duration: 'Suscripción mensual',
    buttonText: 'Elegir mi tema',
    highlightedTitle: 'Autoridad temática',
    highlightedContent: [
      'Tu marca lidera un bloque entero del conversatorio.',
      'Ideal para lanzamientos alineados a estilo de vida o transformación.',
    ],
    highlightedButtonText: 'Ver temas disponibles',
  },
  {
    title: 'Entrevista patrocinada',
    annualPrice: 'Por sesión: 40',
    monthlyPrice: 40,
    features: [
      'Entrevista de 20 minutos en vivo',
      'Proyección de tus videos promocionales',
      'Mención de puntos de venta',
      'Propuesta con respaldo visual en pantalla',
      'Post en redes sociales del programa',
      logoPaginaDofollow,
    ],
    idealFor: 'Emprendedores, coaches, marcas personales y voceros que buscan visibilidad cualificada.',
    duration: '20 minutos por sesión',
    buttonText: 'Agendar entrevista',
    highlightedTitle: 'Proyección y respaldo visual',
    highlightedContent: [
      'Espacio dedicado a tu historia y tu propuesta de valor.',
      'Ideal para humanizar la marca frente a la audiencia del show.',
    ],
    highlightedButtonText: 'Consultar fechas',
  },
  {
    title: 'Post patrocinado en TNO Digest',
    annualPrice: 'Por publicación: 50',
    monthlyPrice: 50,
    features: [
      'Publicación patrocinada en las redes sociales de TNO Digest',
      'Alcance en el ecosistema digital de 3 de Copas y TNO Digest',
      'Contenido adaptado a lifestyle, conversación y cultura',
      logoPaginaDofollow,
    ],
    idealFor: 'Marcas que buscan visibilidad en redes sin compromiso de programa en vivo.',
    duration: 'Por publicación',
    buttonText: 'Solicitar post patrocinado',
    highlightedTitle: 'Visibilidad en TNO Digest',
    highlightedContent: [
      'Tu marca en el feed editorial del ecosistema TNO.',
      'Complemento ideal a una campaña en el programa.',
    ],
    highlightedButtonText: 'Solicitar post',
  },
  {
    title: 'Cápsula de marca / lifestyle',
    annualPrice: 'Pack 5 cápsulas: 150',
    monthlyPrice: 40,
    features: [
      'Cápsula de 60-90 segundos con estética alineada al programa',
      'Distribución en redes sociales de TNO y del show',
      'Tema: mensaje de transformación, lanzamiento o promoción',
      'Locución profesional en línea con el tono de 3 de Copas',
      logoPaginaDofollow,
    ],
    idealFor: 'Promociones puntuales, campañas cortas y refuerzo de mensaje en formato breve.',
    duration: 'Por cápsula',
    buttonText: 'Solicitar cápsula',
    highlightedTitle: 'Impacto en redes',
    highlightedContent: [
      'Formato corto y memorable para máxima recordación.',
      'Tu mensaje viaja con la estética conversacional del programa.',
    ],
    highlightedButtonText: 'Enviar mi propuesta',
  },
  {
    title: 'UGC lifestyle / transformación',
    annualPrice: '80 por pieza',
    monthlyPrice: 80,
    features: [
      'Video dinámico estilo vlog o testimonio en contexto real',
      'Demostración del producto o servicio en una rutina creíble',
      'Narrativa humana alineada al tono del programa',
      'Publicación del video en TNO y en el ecosistema del show',
      'Entrega de archivo original para pauta de la marca',
      logoPaginaDofollow,
    ],
    idealFor: 'Productos de consumo, belleza, moda, bienestar y experiencias que se prestan a historia visual.',
    duration: 'Por pieza',
    buttonText: 'Activar campaña UGC',
    highlightedTitle: 'Prueba social directa',
    highlightedContent: [
      'El contenido UGC genera más confianza que el anuncio tradicional cuando está bien contado.',
      'Posicionamos tu marca como recomendación dentro del universo del programa.',
    ],
    highlightedButtonText: 'Activar campaña UGC',
  },
];

export default optionsData;
